import Form from '../../libs/Form';
import TextInput from '../../libs/TextInput';
import * as yup from "yup";
import { Button } from '../../libs/Button';
import { model } from '../../../language/model';
import { useToastify } from '../../hooks';
interface Credentials {
  username: string,
  password: string
}

const LoginForm = () => {
  const schema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
  }).required();
   const  {toastify} =  useToastify

  const onSubmit = (data: Credentials) => {
    toastify({message : 'Authentification a echoue ! ' , type : 'ERROR' , position:'BOTTOM_CENTER'})
  }

  return (

    <Form onSubmit={(data: Credentials) => onSubmit(data)} shapeValidation={schema}>
      <TextInput name='username' label={model.username} />
      <TextInput name='password' label={model.password} type='password' />
      <Button fullWidth label={model.connection} type='submit' onClick={(e) => { }} />
    </Form>

  )
}

export default LoginForm